// This file initializes GTM and GA4 with consent mode BEFORE React loads
// It should be imported at the very top of index.tsx
declare global {
  interface Window {
    dataLayer: any[]
    gtag: (...args: any[]) => void
  }
}
// Initialize dataLayer
window.dataLayer = window.dataLayer || []
function gtag(...args: any[]) {
  window.dataLayer.push(arguments)
}
window.gtag = gtag
// Set default consent to 'denied' for both ads and analytics
gtag('consent', 'default', {
  ad_storage: 'denied',
  analytics_storage: 'denied',
  wait_for_update: 500,
})
// Initialize GTM with consent mode
gtag('js', new Date())
// Load Google Analytics 4 (GA4) script
const ga4Script = document.createElement('script')
ga4Script.async = true
ga4Script.src = 'https://www.googletagmanager.com/gtag/js?id=G-FQKHRCTG8Y'
document.head.appendChild(ga4Script)
ga4Script.onload = () => {
  // Configure GA4 with page view disabled (we'll track manually)
  gtag('config', 'G-FQKHRCTG8Y', {
    send_page_view: false,
  })
  // Configure Google Ads
  gtag('config', 'AW-17739412957')
}
// Load GTM container script
const gtmScript = document.createElement('script')
gtmScript.innerHTML = `
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-5V2WHRG3');
`
document.head.appendChild(gtmScript)
// Export function to update consent when user accepts cookies
export function updateConsent(
  accepted: boolean,
  options?: { sendInitialPageview?: boolean }
) {
  if (accepted) {
    gtag('consent', 'update', {
      ad_storage: 'granted',
      analytics_storage: 'granted'
    });

    // Only send the first page_view when explicitly requested
    if (options?.sendInitialPageview) {
      gtag('event', 'page_view', {
        page_path: window.location.pathname + window.location.search,
        page_location: window.location.href,
        page_title: document.title
      });

      // Also push to dataLayer for GTM
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'page_view',
          page_path: window.location.pathname + window.location.search,
          page_location: window.location.href,
          page_title: document.title
        });
      }
    }
  }
}